import { useAppLanguage } from '@/hooks/useAppLanguage';
import Colors from '@/constants/colors';
import DetailPageLayout from '@/components/DetailPageLayout';
import DetailPageHeader from '@/components/DetailPageHeader';

export default function ReportIssuePage() {
  const { language } = useAppLanguage();

  const title = language === 'ru' ? 'Сообщить о проблеме' : language === 'pl' ? 'Zgłoś problem' : 'Report an Issue';
  const content = language === 'ru'
    ? 'Обнаружили проблему? Помогите нам улучшить приложение, сообщив об ошибке или предложив улучшение.'
    : language === 'pl'
    ? 'Znaleźli Państwo błąd? Pomóż nam ulepszyć aplikację, zgłaszając problem lub sugerując ulepszenie.'
    : 'Found a bug? Help us improve the app by reporting an issue or suggesting an improvement.';

  return (
    <DetailPageLayout>
      <DetailPageHeader title={title} />
      <div style={styles.content}>
        <p style={styles.bodyText}>{content}</p>
      </div>
    </DetailPageLayout>
  );
}

const styles = {
  content: {
    backgroundColor: Colors.background,
    minHeight: '100vh',
  } as React.CSSProperties,

  bodyText: {
    fontSize: '16px',
    color: Colors.text,
    lineHeight: '24px',
    padding: '24px',
    margin: 0,
  } as React.CSSProperties,
};
